var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DateRangePickerSelector',{attrs:{"value":_vm.dateRangeValues,"label":_vm.label,"allow-future-selection":_vm.filter.config.allowFutureSelection},on:{"change":_vm.onSelectedValuesChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }